import { cloneElement, type ReactElement } from 'react';
import { useWalletConnections } from '../../hooks/useWalletConnections';
import { StyleWalletIconContainer } from './styles';
const WalletIcon = ({ size = 20 }: { size?: number }) => {
  const [walletConnection] = useWalletConnections();

  return (
    <StyleWalletIconContainer width={size} height={size}>
      {
        (walletConnection?.walletProps.icon &&
          cloneElement(
            walletConnection?.walletProps.icon as ReactElement,
            {
              width: size,
              height: size,
            } as any
          )) as any
      }
    </StyleWalletIconContainer>
  );
};

export default WalletIcon;
